import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

const StartJourneySection = () => {

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 },
    },
  };

  return (
    <section className="container mx-auto px-4 py-8 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-sky-50/40 to-emerald-50/30" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_800px_at_100%_20%,rgba(56,189,248,0.12),transparent)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_800px_at_0%_60%,rgba(16,185,129,0.12),transparent)]" />

      <div
        className="absolute top-20 right-[10%] w-24 h-24 bg-sky-400/20 rounded-full blur-xl animate-float"
        style={{ animationDelay: "1s" }}
      />
      <div
        className="absolute bottom-40 left-[5%] w-32 h-32 bg-emerald-400/15 rounded-full blur-xl animate-float"
        style={{ animationDelay: "2s" }}
      />

      <motion.div
        className="relative"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={containerVariants}>
        <motion.div
          className="text-center max-w-3xl mx-auto"
          variants={itemVariants}>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
           Ready to Start Your Freelance Journey?
          </h2>

          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button className="bg-gradient-to-r from-sky-500 to-blue-600 hover:from-sky-600 hover:to-blue-700 text-white shadow-lg shadow-blue-500/20 px-6 h-auto rounded-xl flex items-center gap-2 transition-all duration-300">
              <span className="font-medium">Join Now</span>
            </Button>

            <Button
              variant="outline"
              className="border-2 border-sky-200 hover:border-sky-300 bg-white hover:bg-sky-50 text-sky-700 px-6 h-auto rounded-xl flex items-center gap-2 transition-all duration-300">
              <span className="font-medium">Browse Jobs</span>
            </Button>
          </div>
        </motion.div>
      </motion.div>
    </section>
  )
}

export default StartJourneySection